import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=e665182a&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=ts&"
export * from "./Skills.vue?vue&type=script&lang=ts&"
import style0 from "./Skills.vue?vue&type=style&index=0&id=e665182a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e665182a",
  null
  
)

export default component.exports